module.exports = "/images/check-brand-2-100.svg?629a06b8f2865811bb02a907cf397cf1";